import ReactDOM from 'react-dom/client';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';


import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/lara-light-cyan/theme.css";
// import 'primereact/resources/themes/lara-light-indigo/theme.css'; 
// import 'primeflex/primeflex.css';
 //import 'primereact/resources/primereact.css';
 import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import React from 'react';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <PrimeReactProvider>
      <App />
    </PrimeReactProvider>
  </React.StrictMode>
    // <PrimeReactProvider>
    //   <App />
    // </PrimeReactProvider>
);

reportWebVitals();
